import React from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import HomeMileageInnerContentsEcoKr from '@di-shared/features/home/kr/benefit/HomeMileageInnerContentsEco.kr';
import HomeMileageInnerContentsSafeDrivingKr, {
  HomeMileageInnerContentsSafeDrivingError,
} from '@di-shared/features/home/kr/benefit/HomeMileageInnerContentsSafeDriving.kr';

interface HomeMileageInnerContentsKrProps {
  vin: string;
}

function HomeMileageInnerContentsKr({vin}: HomeMileageInnerContentsKrProps) {
  return (
    <ul className="eco_state_list">
      <HomeMileageInnerContentsEcoKr vin={vin} />
      <ErrorBoundary fallback={<HomeMileageInnerContentsSafeDrivingError />}>
        <HomeMileageInnerContentsSafeDrivingKr vin={vin} />
      </ErrorBoundary>
    </ul>
  );
}

export default HomeMileageInnerContentsKr;

export function HomeMileageInnerContentsOdometerError() {
  const {t} = useInferableTranslation();
  return (
    <ul className="eco_state_list">
      <li className="eco_state_item type_nodata">
        <strong className="eco_state_title">{t('T10129')}</strong>
      </li>
    </ul>
  );
}
